function formatHoursMinutes(minutes, includeUnit = true) {
  if (!minutes || !Number.isInteger(minutes))
    return minutes ? minutes : '';

  var h = Math.floor(minutes / 60);
  var m = minutes % 60;
  return `${h}:${m < 10 ? '0' : ''}${m}${includeUnit ? 'h' : ''}`;
}

module.exports = {
  formatHoursMinutes
}